<div class="shadow-sm rounded-lg flex flex-col h-full">
  <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-medium">Assistant</div>
  <div class="p-4 flex-grow overflow-auto">
    <div class="relative">
      <!-- Loading overlay for initial grid load -->
      <div *ngIf="gridLoading" class="absolute inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-800 bg-opacity-95 dark:bg-opacity-95" style="z-index: 9999;">
        <kendo-loader size="large" themeColor="primary" type="converging-spinner"></kendo-loader>
        <p class="mt-4 text-sm text-gray-600 dark:text-gray-400">Loading assistants...</p>
      </div>
      
      <!-- Spinner overlay for save/delete operations -->
      <div *ngIf="pendingSpinner && !gridLoading" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-30 dark:bg-gray-800 dark:bg-opacity-30" style="z-index: 999;">
        <kendo-loader size="large" themeColor="primary" type="converging-spinner"></kendo-loader>
      </div>
<!--       {{repAssistant | json}} -->
      <kendo-grid
        [kendoGridBinding]="repAssistant"
        (edit)="editHandler($event)"
        (add)="addHandler($event)"
        (save)="saveHandler($event)"
        (cancel)="cancelHandler($event)"
        (remove)="removeHandler($event)"
      >
      <ng-template kendoGridToolbarTemplate>
        <button gdAdminOnly
          type="button"
          kendoGridAddCommand
          kendoButton
          themeColor="primary"
          icon="plus"
          class="mr-2"
        >
          Add New Record
        </button>
        <div class="flex items-center space-x-2 ml-4">
          <label class="text-sm text-gray-700 dark:text-gray-300" for="toggleViewActive">Show Active Only</label>
          <input
            type="checkbox"
            (click)="toggleViewActive()"
            id="toggleViewActive"
            kendoCheckBox
          />
        </div>
        <button
          type="button"
          kendoButton
          icon="refresh"
          class="ml-auto"
          (click)="initGrid()"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column
        field="assistantName"
        title="Assistant Name"
        width="100"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="100"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="assistantEmail"
        title="Assistant Email"
        width="150"
      >
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="255"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="infoLevel" title="Info Level" width="110">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="text-sm">{{ dataItem.infoLevel }}</div>
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeAsisstants"
            textField="infoLevel"
            valueField="assistantLevelID"
            valuePrimitive="true"
            [formControl]="formGroup.get('infoLevelId')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="asstReg"
        title="Asst Reg"
        width="100"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.asstReg" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="receiveAlerts"
        title="Receive Alerts"
        width="150"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.receiveAlerts" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="fingerPrintRequired"
        title="FingerPrint Required"
        width="160"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input
            type="checkbox"
            [checked]="column.fingerPrintRequired"
            disabled
          />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="fingerPrintReceived"
        title="FingerPrint Received"
        width="160"
        [headerStyle]="{ height: 'auto', 'white-space': 'normal' }"
      >
        <ng-template kendoGridCellTemplate let-column>
          <input
            type="checkbox"
            [checked]="column.fingerPrintReceived"
            disabled
          />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column
        field="assistantStartDate"
        title="Start Date"
        width="100"
      >
        <ng-template kendoGridCellTemplate let-column>
          {{ column.assistantStartDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="k-adjust-width"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="assistantEndDate" title="End Date" width="100">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.assistantEndDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="k-adjust-width"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="220" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoGridEditCommand [primary]="true" kendoButton themeColor="primary" icon="edit" class="mr-1">Edit</button>
          <button gdAdminOnly
            kendoButton
            themeColor="info"
            icon="user"
            (click)="goToMembership(dataItem)"
            *ngIf="dataItem.active"
            class="mr-1"
          >
            <span *ngIf="dataItem?.hasWebAccess" class="text-sm" gdAdminOnly>Edit Membership</span>
            <span *ngIf="!dataItem?.hasWebAccess" class="text-sm" gdAdminOnly>Grant Web Access</span>
          </button>
          <button kendoGridRemoveCommand *ngIf="dataItem.active" kendoButton themeColor="error" icon="trash" class="mr-1" gdAdminOnly>Remove</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid" kendoButton themeColor="success" icon="save" class="mr-1" gdAdminOnly>Save</button>
          <button kendoGridCancelCommand kendoButton themeColor="light" icon="cancel" class="mr-1">Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
